export default __webpack_public_path__ + "static/media/menu.fc14f3ae.svg";